









































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import numUtils from "@/utils/numUtils";
import FlipCount from "@/components/flipCount/FlipCount.vue";
import * as types from "@/store/constants/types";
import GeneralUtilsHelper from "@/utils/generalUtils";
import { isIos } from "@/utils/lodash";
import SkipDelayCount from "../skipDelayCount/SkipDelayCount.vue";
@Component({
  components: {
    FlipCount,
    SkipDelayCount
  }
})
export default class FeedCoins extends Vue {
  @Getter(types.GETTER_INFO_BY_OFFER_DATA)
  private offerInfo: any;
  @Getter(types.GETTER_LOCALIZE_PRICE)
  private localizePrice: any;
  @Getter(types.GETTER_SETTING_DATA)
  private settginData: any;
  @Prop({
    default: () => {
      return null;
    }
  })
  private offer: any;
  @Prop({ default: 0 })
  private skipDelayCountNum!: number;
  @Prop({ default: 1 })
  private randomFeedCoinsStatus!: number;

  private randomChances: number = 10;

  get format() {
    return numUtils.format;
  }

  get localizePriceText() {
    return GeneralUtilsHelper.localizePriceText;
  }

  get feedCoinLevel() {
    try {
      // const { feed_coin_offers } = this.settginData;
      // let newFeedCoinsArr = feed_coin_offers.filter((feed: any) => {
      //   return feed.kind === "feed_coin";
      // });

      // console.log("newFeedCoinsArr:", newFeedCoinsArr);

      // newFeedCoinsArr = this.bubbleSort(newFeedCoinsArr);

      // for (const i in newFeedCoinsArr) {
      //   if (this.offer && newFeedCoinsArr[i].offer_id === this.offer.offer_id) {
      //     return `level_${parseInt(i) + 1}`;
      //   }
      // }
      return `level_${this.randomFeedCoinsStatus}`;
    } catch (error) {
      console.log("feedCoinLevel error:", error);
    }
  }

  private bubbleSort = (arr: any) => {
    try {
      const len = arr.length;
      for (let i = 0; i < len; i++) {
        for (let j = 0; j < len - 1 - i; j++) {
          if (arr[j].effect > arr[j + 1].effect) {
            //相邻元素两两对比
            const temp = arr[j + 1]; //元素交换
            arr[j + 1] = arr[j];
            arr[j] = temp;
          }
        }
      }
      return arr;
    } catch (error) {
      console.log("bubbleSort error:", error);
    }
  };

  private localizePriceOriginalText(item: any) {
    if (isIos()) {
      return this.localizePrice(item.iap.product_id)
        ? `${
            this.localizePrice(item.iap.product_id).localSymbol
          } ${numUtils.toDecimal2(
            Math.floor(
              (this.localizePrice(item.iap.product_id).price /
                (1 - item.discount / 100)) *
                100
            ) / 100
          )}`
        : `$ ${this.offerInfo(item).original_price}`;
    } else {
      return `$ ${this.offerInfo(item).original_price}`;
    }
  }

  private mounted() {
    this.randomChances = Math.floor(Math.random() * 40) + 20;
  }
}
